import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { ButtonGroup, Button, Typography } from '@mui/material'

import { PROFILE_TABS_CONFIG } from './profile-tabs.constants'

export const ProfileTabs = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const role = useSelector((state) => state.global.role)
  const currentTabId = location.pathname.split('/').reverse()[0]

  const handleChange = (tabId) => navigate(`/profile/${tabId}`)

  const tabs = PROFILE_TABS_CONFIG({ intl, role })

  return (
    <ButtonGroup size="large" color="primary" style={{ backgroundColor: 'white' }}>
      {tabs.map((tab) => {
        return (
          <Button
            key={tab.id}
            variant={tab.id === currentTabId ? 'contained' : 'outlined'}
            onClick={() => handleChange(tab.id)}
            style={{ lineHeight: 1 }}
          >
            <Typography variant="subtitle2">{tab.label}</Typography>
          </Button>
        )
      })}
    </ButtonGroup>
  )
}
